module.exports = __webpack_public_path__ + "media/images/main_nav_privacy_policy-2ac5138de3b2261b0cf78e6ea55cbe8e.png";